import { IDefaultAvailabilityContent } from "../planEatApi/PlanEatFacade";

export const weekDays : IDefaultAvailabilityContent[] = [
    {
        weekDay : 'Sunday',
        available: false
    },
    {
        weekDay : 'Monday',
        available: false
    },
    {
        weekDay : 'Tuesday',
        available: false
    },
    {
        weekDay : 'Wednesday',
        available: false
    },
    {
        weekDay : 'Thursday',
        available: false
    },
    {
        weekDay : 'Friday',
        available: false
    },
    {
        weekDay : 'Saturday',
        available: false
    },
] 